// src/pages/registration/RegistrationPage.js

import React, { Fragment, useEffect } from "react";
import { Helmet } from "react-helmet-async";
import FullWidthLayout from "../../layouts/FullWidthLayout";
import { useTranslation } from "react-i18next";
import ReactGA from "react-ga4";

import RegistrationContent from "./RegistrationContent";

const RegistrationPage = () => {
  const { t } = useTranslation();

  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: window.location.pathname });
  }, []);

  return (
    <Fragment>
      <Helmet>
        <title>
          {t("common:registrationForm.becomeMember")} -{" "}
          {process.env.REACT_APP_TITLE}
        </title>
      </Helmet>
      <FullWidthLayout>
        <RegistrationContent />
      </FullWidthLayout>
    </Fragment>
  );
};

export default RegistrationPage;
